import { parseISO } from "date-fns";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import {
    buildTransactionRefLabel,
    toTransactionReferenceDate,
    TransactionReference,
} from "@common/schemas/transactionReference.schema";

function counterpartyNameFromTransaction(
    transaction: Pick<
        TransactionListItem,
        "counterparty" | "displayDescription" | "bankDescription"
    >,
): string {
    const candidates = [
        transaction.counterparty?.name,
        transaction.displayDescription,
        transaction.bankDescription,
    ];
    const name = candidates.find(
        (candidate) => candidate != null && candidate.trim().length > 0,
    );
    return name ?? "Transaction";
}

export function buildTransactionReferences({
    taskId,
    transactions,
}: {
    taskId: string;
    transactions: Array<
        Pick<
            TransactionListItem,
            | "id"
            | "amount"
            | "date"
            | "counterparty"
            | "displayDescription"
            | "bankDescription"
        >
    >;
}): TransactionReference[] {
    return transactions.map((transaction) => {
        const date =
            transaction.date instanceof Date
                ? transaction.date
                : parseISO(transaction.date);
        const snapshot = {
            counterpartyName: counterpartyNameFromTransaction(transaction),
            amount: transaction.amount,
            date: toTransactionReferenceDate(date),
        };
        return {
            taskId,
            transactionId: transaction.id,
            ...snapshot,
            label: buildTransactionRefLabel(snapshot),
        };
    });
}
